/**
 * Workflow form page (create/edit) with PageFormLayout.
 * Provides header with back button and page title, wraps WorkflowDesigner component.
 */

// React Imports
import { useParams, useNavigate } from 'react-router-dom';

// Component Imports
import { PageFormLayout } from '../components/layouts/PageFormLayout';
import { WorkflowDesigner } from '../components/workflows/WorkflowDesigner';

/**
 * Workflow form page (create/edit).
 */
export const WorkflowFormPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const isEdit = !!id;

  const handleSave = () => {
    navigate('/workflows');
  };

  const handleCancel = () => {
    navigate('/workflows');
  };

  return (
    <PageFormLayout
      title={isEdit ? 'Edit Workflow' : 'Create Workflow'}
      backTo={{ label: 'Workflows', href: '/workflows' }}
      actions={{
        onSave: handleSave,
        onCancel: handleCancel,
      }}
    >
      <WorkflowDesigner workflowId={id} onSave={handleSave} onCancel={handleCancel} />
    </PageFormLayout>
  );
};
